import { Location } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { filter, switchMap, withLatestFrom } from 'rxjs/operators';
import { App } from 'src/app/app.models';
import { selectRouteParams } from 'src/app/app.selector';
import { environment } from '../../../environments/environment';
import {
  selectBaseEndpoint,
  selectCustomerApiEndpoint,
  selectTestPushCredentials
} from '../../app.selector';
import { TestPushComponent } from '../test-push/test-push.component';

@Component({
  selector: 'app-app-info',
  templateUrl: './app-info.component.html',
  styleUrls: ['./app-info.component.scss'],
})
export class AppInfoComponent implements OnInit {
  app: App
  env = environment
  $basePath: Observable<string>
  $custCred: Observable<{
    name: string
    clearTextPassword: string
    accessToken: string
  }>
  $app: Subscription;
  endpoint: string;
  $context: Subscription;
  subscribers$: Observable<Object>;
  clientId: any;

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private store: Store,
    private dialogService: NbDialogService,
    private title: Title,
    public location: Location
  ) { }

  ngOnInit(): void {
    // context (routing + endpoints)
    const context$ = this.store.select(selectCustomerApiEndpoint).pipe(
      filter((c) => !!c),
      withLatestFrom(this.store.select(selectRouteParams)),
    );

    //set context to component
    this.$context = context$.subscribe(([endpoint, params]) => {
      this.clientId = params.clientId;
      this.endpoint = endpoint;
    });

    // fetch app with given url params as soon as endpoint is there (contract is choosed)
    this.$app = context$.pipe(
      switchMap(([endpoint, params]) =>
        this.http.get(`${endpoint}/apps/${params['id']}`),
      ),
    ).subscribe(
      (app: App) => {
        this.app = app
        this.title.setTitle('Info:' + app.name);
      }, (e: HttpErrorResponse) =>
      this.router.navigate(['/404'], {
        state: { msg: "The app doesn't exist." },
      }),
    )

    this.$custCred = this.store.select(selectTestPushCredentials)
    this.$basePath = this.store.select(selectBaseEndpoint)
  }

  testpush() {
    this.dialogService.open(TestPushComponent, {
      context: {
        contextApp: this.app,
      },
    });
  }

  edit() {
    this.router.navigate(['..'], { relativeTo: this.route });
  }


  ngOnDestroy() {
    this.$app.unsubscribe();
    this.$context.unsubscribe();
  }
}
